import { ContactMethod } from "@/graphql/graphql";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { selectHomepage, setContactMethod, setOpenModal } from "@/redux/state/homepage";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button, Card,
  CardBody,
  CardFooter, CardTitle,
  Col
} from "reactstrap";

const pickService_t_prefix = "pages.homePage.pickService";
interface ContactMethodCardProps {
  method: ContactMethod
}
const ContactMethodCard: React.FC<ContactMethodCardProps> = ({ method }) => {
  const { t } = useTranslation();
  const select = t(`${pickService_t_prefix}.select`);
  const imgPath = t(
    `${pickService_t_prefix}.contactMethods.${method.id}.image`
  );
  const { choices } = useAppSelector(selectHomepage);
  const isChosen = () => choices.contactMethod?.name === method.name;
  const dispatch = useAppDispatch();
  const [isTapped, setIsTapped] = useState(false);
  const handleClick = (e: any) => {
    e.preventDefault();
    dispatch(setContactMethod(method));
    dispatch(setOpenModal({ modal: "contactMethod", isOpen: false }));
  };
  return (
    <Col>
      <Card 
        className="card-method"
        onTouchStart={() => setIsTapped(true)}
        onTouchEnd={() => setIsTapped(false)}>
        <div className="card-image">
          <a href="#pablo" onClick={(e) => e.preventDefault()}>
            <img alt="..." className="img rounded" src={imgPath}></img>
          </a>
        </div>
        <CardBody className="text-center">
          <CardTitle tag="h4" style={{ color: "black" }}>
            {t(`${pickService_t_prefix}.contactMethods.${method.id}.name`)}
          </CardTitle>
          <p className="card-description">
            {t(
              `${pickService_t_prefix}.contactMethods.${method.id}.description`
            )}
          </p>
          <CardFooter>
            <Button
              className={`btn-round select-button ${
                isChosen() ? "isChosen" : isTapped ? "isTapped" : ""
              }`}
              href="#pablo"
              onClick={handleClick}
              onMouseEnter={() => setIsTapped(true)}
              onMouseLeave={() => setIsTapped(false)}
            >
              {select}
            </Button>
          </CardFooter>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ContactMethodCard;
